var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{ref:"cascader",staticStyle:{"width":"100%"},attrs:{"options":_vm.options,"props":_vm.props,"change-on-select":_vm.changeOnSelect},model:{value:(_vm.defaultValue),callback:function ($$v) {_vm.defaultValue=$$v},expression:"defaultValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }